<template>
  <div class="loader_style" v-show="loader == true">
    <atom-spinner :animation-duration="1300" :size="200" :color="'#0BD5E8'" />
  </div>
</template>
<script>

import { AtomSpinner } from "epic-spinners";
export default {
  name: "LoaderComponent",
  components: {
    AtomSpinner,
  },
  props: ["loader"],
};
</script>

<style scoped>
.loader_style {
  background: rgba(58, 56, 56, 0.822);
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
</style>